<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-list>

		<!--OPINIA FORMALNA-->
		<template v-for="(evaluation, index) in offer.formalEvaluations">
			<v-list-tile avatar :key="'formal-evaluation-' + evaluation.id">
				<v-list-tile-avatar>
					<v-icon color="orange">event_seat</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title v-html="evaluation.committeeUser.user.user.name + ' ' +
						evaluation.committeeUser.user.user.surname"></v-list-tile-title>
					<v-list-tile-sub-title>Opinia formalna</v-list-tile-sub-title>
					<span>
						<v-list-tile-action-text
							v-html="getFormalEvaluationStatusText(evaluation)"></v-list-tile-action-text>
						<span v-if="evaluation.evaluationStatus === 'REVISION'" class="ml-1">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon size="16" color="blue" dark v-on="on">info_outline</v-icon>
								</template>
								<span>{{evaluation.detailedCorrectionCause}}</span>
							</v-tooltip>
						</span>
						<span v-else-if="evaluation.evaluationStatus === 'FINISHED'" class="ml-1">
							<v-list-tile-action-text v-if="evaluation.passed === true"
								style="color: green; font-weight: bold" v-html="'(Pozytywna)'"/>
							<v-list-tile-action-text v-else
								style="color: red; font-weight: bold" v-html="'(Negatywna)'"/>
						</span>
					</span>
				</v-list-tile-content>
				<v-list-tile-action>
					<egranty-icon-button
						icon="build"
						color="primary"
						label="Oddaj do poprawek"
						for="offer-evaluation-sublist-give-to-correct-formal"
						id="offer-evaluation-sublist-give-to-correct-formal"
						v-if="evaluation.evaluationStatus === 'FINISHED'"
						:disabled="evaluationManagementDisabled()"
						@click="correctEvaluation('formal', evaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button
						icon="search"
						color="primary"
						label="Zobacz ocenę"
						for="offer-evaluation-sublist-see-rating-formal"
						id="offer-evaluation-sublist-see-rating-formal"
						v-if="evaluation.evaluationStatus === 'FINISHED'"
						@click="viewEvaluation('formal', evaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action v-if="offer.offerStatus === 'SUBMITTED'">
					<egranty-icon-button
						icon="delete"
						color="lightred"
						label="Usuń ocenę"
						for="offer-evaluation-sublist-delete-rating-formal"
						id="offer-evaluation-sublist-delete-rating-formal"
						:disabled="evaluationManagementDisabled()"
						@click="deleteFormalEvaluation(offer, evaluation.id, index)"/>
				</v-list-tile-action>
			</v-list-tile>
		</template>

		<!--OPINIA MERYTORYCZNA-->
		<template v-for="(evaluation, index) in offer.substantiveEvaluations">
			<v-list-tile avatar :key="'substantive-evaluation-' + evaluation.id">
				<v-list-tile-avatar>
					<v-icon color="primary">event_seat</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title v-html="evaluation.committeeUser.user.user.name + ' ' +
						evaluation.committeeUser.user.user.surname"></v-list-tile-title>
					<v-list-tile-sub-title>Opinia merytoryczna</v-list-tile-sub-title>
					<span>
						<v-list-tile-action-text
							v-html="getSubstantiveEvaluationStatusText(evaluation)"></v-list-tile-action-text>
						<span v-if="evaluation.evaluationStatus === 'REVISION'" class="ml-1">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon size="16" color="blue" dark v-on="on">info_outline</v-icon>
								</template>
								<span>{{evaluation.detailedCorrectionCause}}</span>
							</v-tooltip>
						</span>
						<span class="ml-1" v-else-if="evaluation.evaluationStatus === 'FINISHED'">
							<template v-if="evaluation.booleanEvaluation">
								<v-list-tile-action-text v-if="evaluation.recommending === true"
									style="color: green; font-weight: bold" v-html="'(Pozytywna)'"/>
								<v-list-tile-action-text v-else
									style="color: red; font-weight: bold" v-html="'(Negatywna)'"/>
							</template>
							<template v-else-if="evaluation.evaluationPointsSum !== null">
								<v-list-tile-action-text style="color: blue; font-weight: bold"
									v-html="'(' + formatWithoutFixed(evaluation.evaluationPointsSum) + ' p.)'"/>
							</template>
						</span>
					</span>
				</v-list-tile-content>
				<v-list-tile-action>
					<egranty-icon-button
						icon="build"
						color="primary"
						label="Oddaj do poprawek"
						for="offer-evaluation-sublist-give-to-correct-substantive"
						id="offer-evaluation-sublist-give-to-correct-substantive"
						:disabled="evaluationManagementDisabled()"
						v-if="evaluation.evaluationStatus === 'FINISHED'"
						@click="correctEvaluation('substantive', evaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button
						icon="search"
						color="primary"
						label="Zobacz ocenę"
						for="offer-evaluation-sublist-see-rating-substantive"
						id="offer-evaluation-sublist-see-rating-substantive"
						v-if="evaluation.evaluationStatus === 'FINISHED'"
						@click="viewEvaluation('substantive', evaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action v-if="offer.offerStatus === 'SUBMITTED'">
					<egranty-icon-button
						icon="delete"
						color="lightred"
						label="Usuń ocenę"
						for="offer-evaluation-sublist-delete-rating-substantive"
						id="offer-evaluation-sublist-delete-rating-substantive"
						:disabled="evaluationManagementDisabled()"
						@click="deleteSubstantiveEvaluation(offer, evaluation.id, index)"/>
				</v-list-tile-action>
			</v-list-tile>
		</template>
    
		<!--OCENA PLACÓWKI-->
		<template v-if="offer.agencyEvaluation">
			<v-list-tile avatar>
				<v-list-tile-avatar>
					<v-icon color="orange">location_city</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title v-html="offer.agencyEvaluation.agency.name"></v-list-tile-title>
					<v-list-tile-sub-title>Placówka</v-list-tile-sub-title>
					<span>
						<v-list-tile-action-text
							v-html="getAgencyEvaluationStatusText(offer.agencyEvaluation)"></v-list-tile-action-text>
						<span v-if="offer.agencyEvaluation.agencyEvaluationStatus === 'REVISION'" class="ml-1">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon size="16" color="blue" dark v-on="on">info_outline</v-icon>
								</template>
								<span>{{offer.agencyEvaluation.detailedCorrectionCause}}</span>
							</v-tooltip>
						</span>
						<span v-else-if="offer.agencyEvaluation.agencyEvaluationStatus === 'FINISHED'" class="ml-1">
							<v-list-tile-action-text v-if="offer.agencyEvaluation.recommending === true"
								style="color: green; font-weight: bold" v-html="'(Pozytywna)'"/>
							<v-list-tile-action-text v-else
								style="color: red; font-weight: bold" v-html="'(Negatywna)'"/>
						</span>
					</span>
				</v-list-tile-content>
				<v-list-tile-action>
					<egranty-icon-button
						icon="build"
						color="primary"
						label="Oddaj do poprawek"
						for="offer-evaluation-sublist-give-to-correct"
						id="offer-evaluation-sublist-give-to-correct"
						:disabled="evaluationManagementDisabled()"
						v-if="offer.agencyEvaluation.agencyEvaluationStatus === 'FINISHED'"
						@click="correctEvaluation('agency', offer.agencyEvaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button
						icon="search"
						color="primary"
						label="Zobacz ocenę"
						for="offer-evaluation-sublist-see-rating"
						id="offer-evaluation-sublist-see-rating"
						v-if="offer.agencyEvaluation.agencyEvaluationStatus === 'FINISHED'"
						@click="viewEvaluation('agency', offer.agencyEvaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action v-if="offer.offerStatus === 'SUBMITTED'">
					<egranty-icon-button
						icon="delete"
						color="lightred"
						label="Usuń ocenę"
						for="offer-evaluation-sublist-delete-agency"
						id="offer-evaluation-sublist-delete-agency"
						:disabled="evaluationManagementDisabled()"
						@click="deleteAgency(offer)"/>
				</v-list-tile-action>
			</v-list-tile>
		</template>

		<!--OCENA EKSPERTA-->
		<template v-for="(evaluation, index) in offer.expertEvaluations">
			<v-list-tile avatar :key="'expert-evaluation-' + evaluation.id">
				<v-list-tile-avatar>
					<v-icon color="orange">school</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title v-html="evaluation.contestUser.user.name + ' ' +
						evaluation.contestUser.user.surname"></v-list-tile-title>
					<v-list-tile-sub-title>Opinia eksperta</v-list-tile-sub-title>
					<span>
						<v-list-tile-action-text
							v-html="getExpertEvaluationStatusText(evaluation)"></v-list-tile-action-text>
						<span v-if="evaluation.expertEvaluationStatus === 'REVISION'" class="ml-1">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon size="16" color="blue" dark v-on="on">info_outline</v-icon>
								</template>
								<span>{{evaluation.detailedCorrectionCause}}</span>
							</v-tooltip>
						</span>
						<span v-else-if="evaluation.expertEvaluationStatus === 'FINISHED'" class="ml-1">
							<v-list-tile-action-text v-if="evaluation.recommending === true"
								style="color: green; font-weight: bold" v-html="'(Pozytywna)'"/>
							<v-list-tile-action-text v-else
								style="color: red; font-weight: bold" v-html="'(Negatywna)'"/>
						</span>
					</span>
				</v-list-tile-content>
				<v-list-tile-action>
					<egranty-icon-button
						icon="build"
						color="primary"
						label="Oddaj do poprawek"
						for="offer-evaluation-sublist-give-to-correct-expert"
						id="offer-evaluation-sublist-give-to-correct-expert"
						v-if="evaluation.expertEvaluationStatus === 'FINISHED'"
						:disabled="evaluationManagementDisabled()"
						@click="correctEvaluation('expert', evaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button
						icon="search"
						color="primary"
						label="Zobacz ocenę"
						for="offer-evaluation-sublist-see-rating-expert"
						id="offer-evaluation-sublist-see-rating-expert"
						v-if="evaluation.expertEvaluationStatus === 'FINISHED'"
						@click="viewEvaluation('expert', evaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action v-if="offer.offerStatus === 'SUBMITTED'">
					<egranty-icon-button
						icon="delete"
						color="lightred"
						label="Usuń ocenę"
						for="offer-evaluation-sublist-delete-rating-expert"
						id="offer-evaluation-sublist-delete-rating-expert"
						:disabled="evaluationManagementDisabled()"
						@click="deleteExpertEvaluation(offer, evaluation.id, index)"/>
				</v-list-tile-action>
			</v-list-tile>
		</template>

		<!--OPINIA KOŃCOWA-->
		<template v-if="offer.finalEvaluation">
			<v-list-tile avatar>
				<v-list-tile-avatar>
					<v-icon color="orange">event_seat</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title v-html="offer.finalEvaluation.committeeUser.user.user.name + ' ' +
						offer.finalEvaluation.committeeUser.user.user.surname"></v-list-tile-title>
					<v-list-tile-sub-title>Opinia końcowa</v-list-tile-sub-title>
					<span>
						<v-list-tile-action-text
							v-html="getFinalEvaluationStatusText(offer.finalEvaluation)"></v-list-tile-action-text>
						<span v-if="offer.finalEvaluation.finalEvaluationStatus === 'REVISION'" class="ml-1">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon size="16" color="blue" dark v-on="on">info_outline</v-icon>
								</template>
								<span>{{offer.finalEvaluation.detailedCorrectionCause}}</span>
							</v-tooltip>
						</span>
						<span v-else-if="offer.finalEvaluation.finalEvaluationStatus === 'FINISHED'" class="ml-1">
							<v-list-tile-action-text style="color: black; font-weight: bold"
								v-html="'('"/>
							<v-list-tile-action-text v-if="!booleanEvaluation" style="color: black; font-weight: bold"
								v-html="'Ocena łączna: '"/>
							<v-list-tile-action-text v-if="!booleanEvaluation" style="color: blue; font-weight: bold"
								v-html="formatWithoutFixed(offer.finalEvaluation.finalEvaluationPointsSum) + ' p.'"/>
							<v-list-tile-action-text v-if="!booleanEvaluation" style="color: black; font-weight: bold"
								v-html="', '"/>
							<v-list-tile-action-text style="color: black; font-weight: bold"
								v-html="'Opinia komisji: '"/>
							<v-list-tile-action-text v-if="offer.finalEvaluation.committeeDecision === 'RESERVE'"
								style="color: blue; font-weight: bold" v-html="'Rezerwa'"/>
							<v-list-tile-action-text
								v-else-if="offer.finalEvaluation.committeeDecision === 'RECOMMENDED'"
								style="color: green; font-weight: bold" v-html="'Tak'"/>
							<v-list-tile-action-text
								v-else-if="offer.finalEvaluation.committeeDecision === 'NOT_RECOMMENDED'"
								style="color: red; font-weight: bold" v-html="'Nie'"/>
							<v-list-tile-action-text v-else
								style="color: black; font-weight: bold" v-html="'brak'"/>
							<v-list-tile-action-text style="color: black; font-weight: bold"
								v-html="', Decyzja ministra: '"/>
							<v-list-tile-action-text v-if="offer.finalEvaluation.reserved === true"
								style="color: blue; font-weight: bold" v-html="'Rezerwa'"/>
							<v-list-tile-action-text v-else-if="offer.finalEvaluation.ministerDecision === 'PASSED'"
								style="color: green; font-weight: bold" v-html="'Pozytywna'"/>
							<v-list-tile-action-text v-else-if="offer.finalEvaluation.ministerDecision === 'NOT_PASSED'"
								style="color: red; font-weight: bold" v-html="'Negatywna'"/>
							<v-list-tile-action-text v-else
								style="color: black; font-weight: bold" v-html="'Brak'"/>
							<v-list-tile-action-text
								style="color: black; font-weight: bold" v-html="')'"/>
						</span>
					</span>
				</v-list-tile-content>
				<v-list-tile-action>
					<egranty-icon-button
						icon="build"
						color="primary"
						label="Oddaj do poprawek"
						for="offer-evaluation-sublist-give-to-correct-end"
						id="offer-evaluation-sublist-give-to-correct-end"
						:disabled="evaluationManagementDisabled()"
						v-if="offer.finalEvaluation.finalEvaluationStatus === 'FINISHED'"
						@click="correctEvaluation('final', offer.finalEvaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button
						icon="search"
						color="primary"
						label="Podgląd / edycja opinii"
						for="offer-evaluation-sublist-see-rating-end"
						id="offer-evaluation-sublist-see-rating-end"
						v-if="offer.finalEvaluation.finalEvaluationStatus === 'FINISHED'"
						@click="viewEvaluation('final', offer.finalEvaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action
					v-if="offer.finalEvaluation.finalEvaluationStatus === 'FINISHED' && !offer.finalEvaluation.bidderPreviewEnabled">
					<egranty-icon-button icon="screen_share" color="blue lighten-1"
						:disabled="finalEvaluationSharingDisabled"
						label="Udostępnij oferentowi do wglądu"
						@click="enableBidderPreview(offer)"/>
				</v-list-tile-action>
				<v-list-tile-action
					v-if="offer.finalEvaluation.finalEvaluationStatus === 'FINISHED' && offer.finalEvaluation.bidderPreviewEnabled">
					<egranty-icon-button icon="stop_screen_share" color="blue lighten-2"
						:disabled="finalEvaluationSharingDisabled"
						label="Cofnij udostępnienie do wglądu"
						@click="disableBidderPreview(offer)"/>
				</v-list-tile-action>
				<v-list-tile-action v-if="offer.offerStatus === 'SUBMITTED' || offer.offerStatus === 'RESERVED'">
					<egranty-icon-button
						icon="delete"
						color="lightred"
						label="Usuń ocenę"
						for="offer-evaluation-sublist-delete-rating-end"
						id="offer-evaluation-sublist-delete-rating-end"
						:disabled="evaluationManagementDisabled()"
						@click="deleteFinalEvaluation(offer)"/>
				</v-list-tile-action>
			</v-list-tile>
		</template>

		<v-dialog v-model="correctionData.dialog" persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">Przekazanie oceny do poprawek</span>
				</v-card-title>
				<v-card-text>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="correctionCause"
						data-vv-as="Powód przekazania do poprawek"
						label="Powód przekazania do poprawek"
						:error-messages="vErrors.collect('correctionCause')"
						v-validate="'required'"
						@keydown="onKeyDownEvent"
						v-model="correctionCause"
						aria-label="correction cause">
					</v-text-field>
					<v-textarea
						browser-autocomplete="off"
						data-vv-name="detailedCorrectionCause"
						data-vv-as="Opis szczegółowy"
						label="Opis szczegółowy"
						v-model="detailedCorrectionCause"
						:error-messages="vErrors.collect('detailedCorrectionCause')"
						v-validate="'required'"
						aria-label="detailed correction cause">
					</v-textarea>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="correctionCause !== '' && detailedCorrectionCause !== ''"
						color="blue darken-1"
						flat
						@click="sendForCorrection">
						Wyślij
					</v-btn>
					<v-btn
						color="blue"
						@click="correctionData.dialog = false">
						Anuluj
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-list>
</template>
<script>
	import {Api} from "@/api";
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
	import {FormalEvaluation} from "@/api/generated/FormalEvaluation";
	import {SubstantiveEvaluation} from "@/api/generated/SubstantiveEvaluation";
	import {AgencyEvaluation} from "@/api/generated/AgencyEvaluation";
	import {ExpertEvaluation} from "@/api/generated/ExpertEvaluation";
	import {FinalEvaluation} from "@/api/generated/FinalEvaluation";
	import {Numbers} from "@/utils/Numbers";

	export default {
		name: "offer-evaluation-sublist",

		components: {EgrantyIconButton},

		data () {
			return {
				correctionData: {
					dialog: false,
					type: '',
					evaluation: {}
				},
				correctionCause: '',
				detailedCorrectionCause: ''
			};
		},

		mixins: [
			Numbers,
		],

		props: {
			offer: {
				type: Object, default: () => {
				},
			},
			userDomainRole: {
				type: String, default: ''
			},
      contestStatus: {
        type: String, required: true,
      },
			finalEvaluationSharingDisabled: {
				type: Boolean, default: true
			},
			booleanEvaluation: {
				type: Boolean, required: true
			}
		},

		watch: {
			"correctionData.dialog": function (val) {
				if (!val) {
					this.correctionCause = '';
					this.detailedCorrectionCause = '';
				}
			}
		},

		methods: {
			onKeyDownEvent (evt) {
				if (this.correctionCause.length >= 255 && evt.keyCode >= 48 && evt.keyCode <= 90) evt.preventDefault();
			},

			deleteAgency (offer) {
				this.$confirm("Czy na pewno chcesz usunąć opinię placówki?", {
					icon: 'delete',
					title: 'Usunięcie opinii placówki',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							AgencyEvaluation.delete(this, offer.agencyEvaluation.id,
								successResponse => {
									this.$emit("agency-evaluation-removed", offer.id);
									this.$messagesBus.$emit("success", "Pomyślnie usunięto opinię", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć opinii", errorResponse);
								});
						}
					});
			},

			deleteFormalEvaluation (offer, evaluationId, index) {
				this.$confirm("Czy na pewno chcesz usunąć opinię formalną?", {
					icon: 'delete',
					title: 'Usunięcie opinii formalnej',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							FormalEvaluation.delete(this, evaluationId,
								successResponse => {
									this.$emit("formal-evaluation-removed", offer.id, index);
									this.$messagesBus.$emit("success", "Pomyślnie usunięto opinię", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć opinii", errorResponse);
								});
						}
					});
			},

			deleteSubstantiveEvaluation (offer, evaluationId, index) {
				this.$confirm("Czy na pewno chcesz usunąć opinię merytoryczną?", {
					icon: 'delete',
					title: 'Usunięcie opinii merytorycznej',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							SubstantiveEvaluation.delete(this, evaluationId,
								successResponse => {
									this.$emit("substantive-evaluation-removed", offer.id, index);
									this.$messagesBus.$emit("success", "Pomyślnie usunięto opinię", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć opinii", errorResponse);
								});
						}
					});
			},

			deleteFinalEvaluation (offer) {
				this.$confirm("Czy na pewno chcesz usunąć ocenę końcową?", {
					icon: 'delete',
					title: 'Usunięcie oceny końcowej',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							FinalEvaluation.delete(this, offer.finalEvaluation.id,
								successResponse => {
									this.$emit("final-evaluation-removed", offer.id);
									this.$messagesBus.$emit("success", "Pomyślnie usunięto ocenę", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć oceny", errorResponse);
								});
						}
					});
			},

			enableBidderPreview(offer) {
				FinalEvaluation.putEnableBidderPreview(this, offer.finalEvaluation.id,
					successResponse => {
						this.$emit("bidder-preview-changed", offer.id, true);
						this.$messagesBus.$emit("success", "Pomyślnie udostępniono ocenę do wglądu", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się udostępnić oceny do wglądu", errorResponse);
					});
			},

			disableBidderPreview(offer) {
				FinalEvaluation.putDisableBidderPreview(this, offer.finalEvaluation.id,
					successResponse => {
						this.$emit("bidder-preview-changed", offer.id, false);
						this.$messagesBus.$emit("success", "Pomyślnie cofnięto udostępnienie", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się cofnąć udostępnienia", errorResponse);
					});

			},

			evaluationManagementDisabled () {
				return this.contestStatus === "FINISHED"
            || (!this.roles.isAdministrator() && !this.roles.isLocalAdministrator() &&
                !['SECRETARY', 'MAIN_SECRETARY', 'LEADER', 'MAIN_LEADER'].includes(this.userDomainRole));
			},

			editFinalEvaluationDisabled(){
				return (!this.roles.isAdministrator() && !this.roles.isLocalAdministrator() &&
                !['SECRETARY', 'MAIN_SECRETARY'].includes(this.userDomainRole));
			},

			deleteExpertEvaluation (offer, evaluationId, index) {
				this.$confirm("Czy na pewno chcesz usunąć opinię eksperta?", {
					icon: 'delete',
					title: 'Usunięcie opinii eksperta',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							ExpertEvaluation.delete(this, evaluationId,
								successResponse => {
									this.$emit("expert-evaluation-removed", offer.id, index);
									this.$messagesBus.$emit("success", "Pomyślnie usunięto opinię", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć opinii", errorResponse);
								});
						}
					});
			},

			/**
			 * redundancja kodu z powodu:
			 * a) innych nazw atrybutu statusu
			 * b) możliwości zmiany słowników dla poszczególnych typów opinii
			 */
			getAgencyEvaluationStatusText (evaluation) {
				switch (evaluation.agencyEvaluationStatus) {
					case "NOT_STARTED":
						return "Nierozpoczęta";
					case "INAPPROPRIATE_ASSIGNMENT":
						return "Niewłaściwie przypisana";
					case "STARTED":
						return "Rozpoczęta";
					case "REVISION":
						return "Do poprawek: " + evaluation.correctionCause;
					case "FINISHED":
						return "Zakończona";
				}
			},

			getFormalEvaluationStatusText (evaluation) {
				switch (evaluation.evaluationStatus) {
					case "NOT_STARTED":
						return "Nierozpoczęta";
					case "INAPPROPRIATE_ASSIGNMENT":
						return "Niewłaściwie przypisana";
					case "STARTED":
						return "Rozpoczęta";
					case "REVISION":
						return "Do poprawek: " + evaluation.correctionCause;
					case "FINISHED":
						return "Zakończona";
				}
			},

			getSubstantiveEvaluationStatusText (evaluation) {
				switch (evaluation.evaluationStatus) {
					case "NOT_STARTED":
						return "Nierozpoczęta";
					case "INAPPROPRIATE_ASSIGNMENT":
						return "Niewłaściwie przypisana";
					case "STARTED":
						return "Rozpoczęta";
					case "REVISION":
						return "Do poprawek: " + evaluation.correctionCause;
					case "FINISHED":
						return "Zakończona";
				}
			},

			getFinalEvaluationStatusText (evaluation) {
				switch (evaluation.finalEvaluationStatus) {
					case "NOT_STARTED":
						return "Nierozpoczęta";
					case "INAPPROPRIATE_ASSIGNMENT":
						return "Niewłaściwie przypisana";
					case "STARTED":
						return "Rozpoczęta";
					case "REVISION":
						return "Do poprawek: " + evaluation.correctionCause;
					case "FINISHED":
						return "Zakończona";
				}
			},

			getExpertEvaluationStatusText (evaluation) {
				switch (evaluation.expertEvaluationStatus) {
					case "NOT_STARTED":
						return "Nierozpoczęta";
					case "INAPPROPRIATE_ASSIGNMENT":
						return "Niewłaściwie przypisana";
					case "STARTED":
						return "Rozpoczęta";
					case "REVISION":
						return "Do poprawek: " + evaluation.correctionCause;
					case "FINISHED":
						return "Zakończona";
				}
			},

			viewEvaluation (type, evaluation) {
				let suffix = "/" + type + "-evaluation/" + evaluation.id;
				this.$router.push("/app/contest/".concat(this.$route.params.id).concat(suffix));
			},
			editEvaluation(type, evaluation){
				let suffix = "/" + type + "-evaluation/" + evaluation.id;
				this.$router.push("/app/contest/".concat(this.$route.params.id).concat(suffix));
			},
			correctEvaluation (type, evaluation) {
				this.correctionData.type = type;
				this.correctionData.evaluation = evaluation;
				this.correctionData.dialog = true;
			},

			sendForCorrection () {
				Api.put(this, "/" + this.correctionData.type + "-evaluation/correction?evaluationId=" + this.correctionData.evaluation.id, {
          correctionCause: this.correctionCause,
          detailedCorrectionCause: this.detailedCorrectionCause,
        }, successResponse => {
					if (this.correctionData.type === 'expert') {
						this.correctionData.evaluation.expertEvaluationStatus = "REVISION";
					} else if (this.correctionData.type === 'final') {
            this.correctionData.evaluation.finalEvaluationStatus = "REVISION";
            this.$emit("final-evaluation-correction-requested", this.correctionData.evaluation.id);
          } else {
						this.correctionData.evaluation.evaluationStatus = "REVISION";
					}
					this.correctionData.evaluation.correctionCause = this.correctionCause;
					this.correctionData.evaluation.detailedCorrectionCause = this.detailedCorrectionCause;
					this.correctionData.dialog = false;
					this.vErrors.clear();
					this.$emit("update-warning-codes");
					this.$messagesBus.$emit("success", "Ocena została odesłana do poprawek", successResponse);
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się odesłać oceny do poprawek", errorResponse);
				});
			}
		},
	};
</script>
 <style scoped>


 </style>
